import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(async () => {
        if (sessionStorage.getItem("section_portal_token")) {
          sessionStorage.removeItem("section_portal_token");
          sessionStorage.removeItem("section_portal_expires_at");
          setUser(false);
          return;
        }
        try {
          const r = await api.post("/auth/refresh");
          setUser(r.data);
        } catch {
          setUser(false);
        }
      });
  }, []);

  const login = useCallback(async (email, password) => {
    sessionStorage.removeItem("section_portal_token");
    sessionStorage.removeItem("section_portal_expires_at");
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data);
    return r.data;
  }, []);

  const logout = useCallback(async () => {
    if (sessionStorage.getItem("section_portal_token")) {
      sessionStorage.removeItem("section_portal_token");
      sessionStorage.removeItem("section_portal_expires_at");
      setUser(false);
      return;
    }
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
